import { Box } from '@mui/material';

import { useLocation } from 'react-router-dom';

import { mainRoute } from '@src/utils/consts/routesMainMenu.const';
import { compareKeyAndValue } from '@src/utils/functions/compareUrlInMenu.util';

import BreadcrumbCustom from './breadcumb.common';

export default function Container({
  children,
  actionRight,
  className,
  pathUrl = '/',
  sx = { px: '1rem', pt: '2.5rem' },
  childrenSx = { pt: '1.75rem' },
  breadcrumbItems,
  disableBreadcrumb = false,
}) {
  const pathSelf = useLocation().pathname;

  // Determine breadcrumb items
  let finalBreadcrumbItems = [];

  if (breadcrumbItems && breadcrumbItems.length > 0) {
    // If explicit breadcrumbItems are provided, use them directly
    finalBreadcrumbItems = breadcrumbItems;
  } else {
    // Fallback to existing logic for backward compatibility
    const currentMenuKey = compareKeyAndValue(pathSelf || pathUrl);

    if (currentMenuKey) {
      const menuParts = currentMenuKey.split('_');
      const menuCategory = menuParts[0]; // e.g., 'MISC', 'DATABASE'
      const currentPageName = menuParts.slice(1).join(' '); // e.g., 'ANALYTICS', 'CLINIC BRANCH'

      // Add the main menu category as the first item (e.g., 'MISC')
      finalBreadcrumbItems.push({
        label: menuCategory,
        // You might want a path for the main category if it leads to a summary page
        // For now, leaving it without a path if it's just a category label
      });

      // Add the current page as the last item
      finalBreadcrumbItems.push({
        label: currentPageName,
        path: mainRoute[currentMenuKey], // Use the actual path from mainRoute
      });
    } else {
      // Fallback for routes not found in mainRoute, e.g., root or specific IDs
      // This is a basic fallback; you might want more sophisticated logic for dynamic routes
      const pathSegments = (pathSelf || pathUrl).split('/').filter(Boolean);
      if (pathSegments.length > 0) {
        let currentPath = '';
        pathSegments.forEach((segment, index) => {
          currentPath += `/${segment}`;
          finalBreadcrumbItems.push({
            label: segment.replace(/-/g, ' ').toUpperCase(),
            path: index < pathSegments.length - 1 ? currentPath : undefined,
          });
        });
      }
    }
  }

  return (
    <Box className={className} sx={sx}>
      {disableBreadcrumb ? null : (
        <Box className='relative'>
          <BreadcrumbCustom items={finalBreadcrumbItems} />

          {actionRight ? (
            <Box className='flex w-[95%] justify-end px-4'>{actionRight}</Box>
          ) : null}
        </Box>
      )}

      <Box sx={childrenSx}>{children}</Box>
    </Box>
  );
}
